import { uuidV4 } from "@sourcewhale/core";

const closeBtn = `
    <span style="display:flex;">
      <svg xmlns=http://www.w3.org/2000/svg" width="16" height="16" fill="#919191" class="bi bi-x-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/></svg>
    </span>`;

export const initializeCleartext = () => {
  $(".search-box").each((_, el) => {
    const isTagSearch = $(el).hasClass("tag-clear");

    const id = uuidV4();

    $(el).after(
      `<span id="${id}" class="clearTextCloseBtn" style='display:none;align-self:center;margin-right:10px;cursor:pointer;z-index:10;${
        isTagSearch
          ? "right: 40px;top: 12px;position: absolute;"
          : "right:20px;top:32px"
      }'>${closeBtn}</span>`,
    );

    $(`#${id}`).click(() => {
      $(el).val("");
      el.dispatchEvent(new Event("keyup"));
      $(`#${id}`).hide();
    });

    $(el).on("input", () => {
      $(`#${id}`).toggle($(el).val().length > 0);
    });
  });

  $(document).on("loaded.bs.select", (e) => {
    const el = $(e.target).parent().find(".bs-searchbox")[0];

    const input = $(el).find("input")[0];

    const id = uuidV4();

    $(el).append(
      `<span id="${id}" style="display:none;align-self:center;margin-right:10px;cursor:pointer;z-index:10;position:absolute;right:20px;top:32px;">${closeBtn}</span>`,
    );

    $(`#${id}`).click((ev) => {
      $(input).val("");
      input.dispatchEvent(new Event("input"));
      $(`#${id}`).hide();
      ev.stopPropagation();
    });

    $(input).on("input", () => {
      $(`#${id}`).toggle($(input).val().length > 0);
    });
  });
};
